import type { GetPopupContainer } from 'antd/lib/table/interface';

// Antd has z-index issues when it comes to Table dropdowns.
// This aims to make the filters of the table appear when the table is
// inside of a modal.
export const getPopupContainerForTable: GetPopupContainer = (triggerNode) =>
  (triggerNode?.parentNode?.parentNode?.parentNode as HTMLElement) ||
  document.body;
